<template>
  <ion-button
    expand="block"
    type="submit"
    class="ion-no-margin"
    :disabled="submitting"
    :data-cy="dataCy"
  >
    <slot></slot>
    <ion-spinner
      slot="end"
      v-if="submitting"
      class="ion-margin-start"
    ></ion-spinner>
  </ion-button>
</template>

<script>
export default {
  props: {
    submitting: {
      required: true,
      type: Boolean,
      default: false
    },
    dataCy: {
      required: false,
      type: String,
      default: ""
    }
  }
};
</script>
